enum SessionState {
  NoSession = 1,
  Started = 2,
  Retreived = 3,
  Ended = 4,
}

export { SessionState };
